import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createBrand = (_, payload) => {
  return Api(ENDPOINTS.BRAND.CREATE, payload, requestType.POST);
};

const updateBrand = (id, payload) => {
  return Api(
    ENDPOINTS.BRAND.UPDATE.replace(":id", id),
    payload,
    requestType.PUT,
  );
};

const getBrandById = (id) => {
  return Api(ENDPOINTS.BRAND.SINGLE.replace(":id", id), null, requestType.GET);
};

const getBrandBySlug = (slug) => {
  return Api(
    ENDPOINTS.BRAND.SINGLE_BY_SLUG.replace(":slug", slug),
    null,
    requestType.GET,
  );
};

const getBrands = (params = {}) => {
  const ENDPOINT = ENDPOINTS.BRAND.GET;

  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;

  return Api(finalUrl, null, requestType.GET);
};

export { createBrand, updateBrand, getBrandById, getBrandBySlug, getBrands };
